<ng-container *ngIf="hint; else legacy">
    <ph-hint *ngIf="errorMessage" has-error><span [innerHTML]="errorMessage"></span></ph-hint>
</ng-container>

<ng-template #legacy>
    <span *ngIf="errorMessage" [innerHTML]="errorMessage" class="form-error-message text-danger"></span>
</ng-template>

<span *ngIf="saved" [innerHTML]="successMessage" class="form-success-message text-success"></span>
